import { createFileRoute } from '@tanstack/react-router'

import { CpmsPageSkeleton } from '#/modules/health/front-office/cpms-page/cpms-page-skeleton.tsx'
import { CpmsPage } from '#/modules/health/front-office/cpms-page/cpms-page.tsx'

export const Route = createFileRoute('/(customer)/_shell/health-insurance/cpms')({
  pendingComponent: CpmsPageSkeleton,
  pendingMs: 150,
  component: CpmsPage,
})
